import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import OverwriteMomentBE from "../common/datePicker/overwriteMomentBE";
import * as Yup from "yup";
import { ErrorMessage, Field, Form, Formik } from "formik";
import moment from "moment";
import scheduleService from "../../services/schedule.service";
import Swal from "sweetalert2";
const CreateSchedule = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const CreateScheduleSchema = Yup.object().shape({
    year: Yup.number()
      .required("ระบุปีการศึกษาด้วยครับ")
      .typeError("ระบุเป็นตัวเลขเท่านั้น"),
    type: Yup.string().required("เลือกประเภทเอกสารด้วยครับ"),
    term: Yup.string().required("เลือกภาคการศึกษาด้วยครับ"),
    doc3: Yup.date().nullable().required("อย่าลืม! กรอกชื่อหลักสูตรด้วยครับ"),
    doc5: Yup.date().nullable().required("อย่าลืม! กรอกชื่อหลักสูตรด้วยครับ"),
  });

  const onSubmit = (values: any) => {
    // console.log(values);
    const { doc3, doc5, ...etc } = values;

    const data = {
      ...etc,
      doc3: moment(doc3.format("YYYY/MM/DD HH:mm:ss")).format(
        "YYYY-MM-DD HH:mm:ss"
      ),
      doc5: moment(doc5.format("YYYY/MM/DD HH:mm:ss")).format(
        "YYYY-MM-DD HH:mm:ss"
      ),
    };

    scheduleService
      .newSchedule(data)
      .then(() => {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "บันทึกข้อมูลสำเร็จ",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          handleClose();
          window.location.reload();
        });
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "มีบางอย่างผิดพลาด ตรวจสอบข้อมูลอีกครั้ง!",
        });
      });
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-success text-white"
        onClick={handleShow}
      >
        <i className="bi bi-folder-plus"></i> เพิ่ม
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        // centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            เพิ่มกำหนดการใหม่
          </Modal.Title>
        </Modal.Header>
        <Formik
          validationSchema={CreateScheduleSchema} //กำหนด validation Schema
          initialValues={{
            //กำหนด initialValues
            doc3: moment().add(0, "years"),
            doc5: moment().add(0, "years"),
            term: "",
            year: "",
            type: "",
          }}
          onSubmit={onSubmit}
        >
          {({
            handleBlur,
            handleChange,
            values,
            errors,
            touched,
            setFieldValue,
          }) => (
            <Form>
              <Modal.Body>
                <div className="row g-3">
                  <div className="col-12">
                    <label htmlFor="type" className="form-label">
                      กำหนดการสำหรับเอกสาร
                    </label>
                    <select
                      name="type"
                      className={`form-select ${
                        touched.type
                          ? errors.type
                            ? "is-invalid"
                            : "is-valid"
                          : ""
                      }`}
                      value={values.type}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <option value="">เลือกประเภทเอกสาร</option>
                      <option value="tqf">มคอ.</option>
                      <option value="mhesi">อชว.</option>
                    </select>
                    <ErrorMessage
                      name="type"
                      className="invalid-feedback"
                      component="div"
                    />
                  </div>
                  <div className="col-6">
                    <label htmlFor="year" className="form-label">
                      ปีการศึกษา
                    </label>
                    <Field
                      type="text"
                      className={`form-control ${
                        touched.year
                          ? errors.year
                            ? "is-invalid"
                            : "is-valid"
                          : ""
                      }`}
                      name="year"
                    />
                    <ErrorMessage
                      name="year"
                      className="invalid-feedback"
                      component="div"
                    />
                  </div>
                  <div className="col-6">
                    <label htmlFor="term" className="form-label">
                      ภาคการศึกษา
                    </label>
                    <select
                      name="term"
                      className={`form-select ${
                        touched.term
                          ? errors.term
                            ? "is-invalid"
                            : "is-valid"
                          : ""
                      }`}
                      value={values.term}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <option>เลือกภาคเรียน</option>
                      <option value="1">ภาคเรียนที่ 1</option>
                      <option value="2">ภาคเรียนที่ 2</option>
                      <option value="3">ภาคฤดูร้อน</option>
                    </select>
                    <ErrorMessage
                      name="term"
                      className="invalid-feedback"
                      component="div"
                    />
                  </div>

                  <MuiPickersUtilsProvider
                    utils={OverwriteMomentBE}
                    locale="th"
                  >
                    <div className="col-md-6">
                      <label htmlFor="doc3" className="form-label">
                        กำหนดการส่งเอกสาร มคอ/อชว. 3 
                      </label>
                      <DatePicker
                        // id="doc3"
                        name="doc3"
                        className={`form-control`}
                        format="DD/MM/YYYY"
                        placeholder="10/10/2018"
                        value={values.doc3}
                        onChange={(value) => setFieldValue("doc3", value)}
                      />
                      <ErrorMessage
                        name="doc3"
                        className="invalid-feedback"
                        component="div"
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="doc5" className="form-label">
                        กำหนดการส่งเอกสาร มคอ/อชว. 5
                      </label>
                      <DatePicker
                        // id="doc5"
                        name="doc5"
                        className="form-control"
                        format="DD/MM/YYYY"
                        value={values.doc5}
                        // placeholder="10/10/2018"
                        onChange={(value) => setFieldValue("doc5", value)}
                      />
                      <ErrorMessage
                        name="doc5"
                        className="invalid-feedback"
                        component="div"
                      />
                    </div>
                  </MuiPickersUtilsProvider>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button type="submit" className="btn btn-primary">
                  เพิ่มข้อมูล
                </button>
                <button type="reset" className="btn btn-warning">
                  ล้าง
                </button>

                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleClose}
                >
                  Close
                </button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default CreateSchedule;
